export const KIND_LABELS = { adicional: "Adicionais", complemento: "Complementos", variacao: "Variações" };

export function groupLimits(g) {
  const max = g.max || (g.type === "single" ? 1 : null);
  const min = g.required ? Math.max(1, Number(g.min) || 1) : 0;
  return { min, max: max ? Number(max) : null };
}

export function limitText(g) {
  const { min, max } = groupLimits(g);
  const parts = [g.required ? "obrigatório" : "opcional"];
  if (max === 1) parts.push("escolha 1");
  else if (min && max) parts.push(min === max ? `escolha ${min}` : `de ${min} a ${max}`);
  else if (min) parts.push(`mínimo ${min}`);
  else if (max) parts.push(`até ${max}`);
  return parts.join(" · ");
}

export function togglePick(sel, g, name) {
  const cur = sel[g.name] || [];
  const { max } = groupLimits(g);
  if (cur.includes(name)) return { ...sel, [g.name]: cur.filter((x) => x !== name) };
  if (max === 1) return { ...sel, [g.name]: [name] };
  return max && cur.length >= max ? sel : { ...sel, [g.name]: [...cur, name] };
}

export function summarize(p, sel) {
  const groups = p.option_groups || [];
  const options = groups.flatMap((g) => (sel[g.name] || []).map((name) => ({ group: g.name, name })));
  const extra = options.reduce((s, o) => s + Number(groups.find((g) => g.name === o.group).options.find((x) => x.name === o.name)?.price || 0), 0);
  const missing = groups.find((g) => (sel[g.name] || []).length < groupLimits(g).min);
  const label = options.length ? ` (${options.map((o) => o.name).join(", ")})` : "";
  return { options, extra, missing, missingText: missing ? `Escolha ${groupLimits(missing).min > 1 ? `${groupLimits(missing).min} em ` : ""}${missing.name}` : "", label };
}
